import debounce from "lodash.debounce";

import windowSize from "../../shared/helpers/window_size"

import { initEnquiry } from "../../utils/Enquiries"

const DEBOUNCE_DELAY = 125;
const SPACING_UNIT = 28 // == $spacing-unit in CSS

const toggleScrollPrompt = (prompt, toggle) => {
  prompt.classList.toggle("is-hidden", !toggle)
}

const setHeight = () => {
  if (windowSize.isHandheld()) return

  const enquiry = document.getElementById("js-venue-enquiry")

  if (!enquiry) {
    return;
  }

  const viewportHeight = window.innerHeight
  const contents = enquiry.querySelectorAll(".js-enquiry-content")
  const headers = enquiry.querySelectorAll(".js-enquiry-header")
  const ctas = enquiry.querySelectorAll(".js-enquiry-ctas")
  const prompts = enquiry.querySelectorAll(".js-scroll-prompt")

  contents.forEach((content, i) => {
    const headerHeight = headers[i].offsetHeight
    const ctaHeight = ctas[i].offsetHeight
    const maxHeight = viewportHeight - headerHeight - ctaHeight - (6 * SPACING_UNIT)
    const hasScroll = content.scrollHeight > content.clientHeight

    content.style.maxHeight = `${maxHeight}px`
    toggleScrollPrompt(prompts[i], hasScroll)
  })
}

const setWidth = () => {
  const enquiry = document.getElementById("js-venue-enquiry")

  if (!enquiry) {
    return;
  }

  if (windowSize.isHandheld()) {
    enquiry.style.width = "auto"
  } else {
    const offersWidth = document.getElementById("js-offers-container").clientWidth
    const enquiryWidthPct = windowSize.isLap() ? 0.5 : 0.4 // u-1/2 and u-2/5 in CSS

    enquiry.style.width = `
      ${(offersWidth * (enquiryWidthPct / (1 - enquiryWidthPct))) - (2 * SPACING_UNIT)}px
    `
  }
}

const setPosition = () => {
  const container = document.getElementById("js-venue-enquiry-container")

  if (!container) {
    return;
  }

  const prevSibling = container.previousElementSibling
  const nextSibling = container.nextElementSibling
    ? container.nextElementSibling
    : container.parentNode.insertBefore(document.createElement("div"), null)

  if (windowSize.isHandheld()) {
    prevSibling.style.marginBottom = "auto"
    nextSibling.style.marginTop = "auto"
  } else {
    const prevSiblingHeight = prevSibling.offsetHeight

    prevSibling.style.marginBottom = `${-prevSiblingHeight}px`
    nextSibling.style.marginTop = `${prevSiblingHeight}px`
  }
}

const hidePromptsOnFirstScroll = () => {
  const contents = document.querySelectorAll(".js-enquiry-content")
  const prompts = document.querySelectorAll(".js-scroll-prompt")

  contents.forEach((content, i) => {
    content.addEventListener("scroll", () => {
      toggleScrollPrompt(prompts[i], false)
      content.removeEventListener("scroll", toggleScrollPrompt)
    })
  })
}

export const setLayout = () => {
  if (document.querySelector("#courses .expert-tips")) {
    return;
  }

  setHeight()
  setWidth()
  setPosition()
}

const updateLayoutOnViewportChange = () => {
  const events = ["resize", "orientationchange"]
  events.forEach(evt => window.addEventListener(evt, debounce(() => {
    setLayout();
  }, DEBOUNCE_DELAY)));
}

export default () => {
  initEnquiry(document.querySelector("#js-venue-enquiry"))
  setLayout()
  updateLayoutOnViewportChange()
  hidePromptsOnFirstScroll()
}



// WEBPACK FOOTER //
// ./components/enquiries/venue_enquiry.js